module.exports = __webpack_public_path__ + "static/img/9.fb1f5f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/sp/9.png
// module id = ubhK
// module chunks = 0